export default "__VITE_ASSET__73e34c51__"